'use client'
import { useState, useEffect, forwardRef } from "react";
import axios from 'axios';
import { formatModuleList, formatWorkflowTree } from '../../lib/utils';
import { workflow } from "../../lib/constants";
import WorkflowStructure from "../workflowstructure/workflow-structure";
import Multiselect from './multiselectControl';
import '../rc-tree-style.css';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import Slide from '@mui/material/Slide';
import { TransitionProps } from '@mui/material/transitions';

import Chip from '@mui/material/Chip';
import Stack from '@mui/material/Stack';
import { preventDeleteTableCell } from "@udecode/plate-table";
import { ModulePage } from "../types/types";
import { description } from "node_server/src/db/schema";
import { formType } from "@/constants/TemplateConstants";


const API_URL = process.env.NEXT_PUBLIC_API_URL;

const Transition = forwardRef(function Transition(
    props: TransitionProps & {
        children: React.ReactElement<any, any>;
    },
    ref: React.Ref<unknown>,
) {
    return <Slide direction="up" ref={ref} {...props} />;
});


export default function TemplateDetails(props) {
    const [allModules, setAllModules] = useState([])
    const [selectedModulePage, setSelectedModulePage] = useState<string>("");
    const [workflowList, setWorkflowList] = useState<any[]>([]);
    const [workflowTreeData, setWorkflowTreeData] = useState<any[]>([]);
    const [selectedWorkflow, setSelectedWorkflow] = useState<string | number>("");
    const [open, setOpen] = useState<boolean>(false);
    const [templateName, setTemplateName] = useState<string>("");
    const [templateDescription, setTemplateDescription] = useState<string>("");
    const [selectedNotiGrp, setSelectedNotiGrp] = useState<string[]>([]);
    const [allWorkflowsSelections, setAllWorkflowsSelections] = useState<string[]>([]);
    const [modulePages, setModulePages] = useState<ModulePage[]>([]);
    const [xmlTree, setXmltree] = useState<any[]>([])

    const handleClose = () => {
        setOpen(false);
    };

    useEffect(() => {
        axios.get(API_URL + "module").then(result => {
            let allModules = formatModuleList(result.data);
            setAllModules(allModules)
        })
    }, []);
    useEffect(() => {
        if (props.templateDetailsData.module?.split(",").length > 1 && props.templateDetailsData.pageModuleId) {
            const moduleValue = allModules.find(m => m.label.trim() === modulePages.find(p => p.ModulePageId === props.templateDetailsData.pageModuleId)?.PageModuleName)?.value;
            if(moduleValue) props.setModule(moduleValue.toString())
        }
    }, [
        props.templateDetailsData.pageModuleId,
        props.templateDetailsData.module
    ]);
      
    useEffect(() => {
        const init = async () => {
            if (props.templateDetailsData.pageModuleId) {
                const workFlows = await fetchWorkflowsForPage(props.templateDetailsData.pageModuleId);

                if (props.templateDetailsData.wfId && workFlows.length > 1) {
                    await handleWorkflowSelection({
                        target: { value: props.templateDetailsData.wfId }
                    }, workFlows);
                }
                if(props.templateDetailsData.type){
                    axios.post(API_URL + "templates/getPlaceholders", { formName: props.templateDetailsData.pageModuleId, category: props.templateDetailsData.type }).then(placeHoldersData => {
                        props.setPlaceholdersForTemplates(placeHoldersData.data);
                    })
                }
            }
        };
    
        if (props.editTemp) {
            init();
        }
    }, [props.editTemp, props.templateDetailsData?.templateId]);

    const handleModuleSelection = (allSelectedModules) => {
        let modulesWithPages = [{ ModulePageName: "Select Module Page" }];
        let allModuleIds: number[] = [];
        allSelectedModules.forEach((module: any) => {
            allModuleIds.push(module);
        });

        props.setTemplateDetailsData((prev) => ({
            ...prev,
            module: allModuleIds.join(","),
        }));              

        axios.post(API_URL + "module/modulePages", { allModuleIds: allModuleIds }).then(result => {
            modulesWithPages.push(...result.data)
            setModulePages(modulesWithPages);
        });
    }

    const getWorkflowList = (allModules) => {
        let allModuleIds = allModules.map(module => {
            return module;
        });
        let templateNameArrya = props.templateDetailsData.name.split("_")
        let selectedWorkflow = templateNameArrya[0];
        let selectedWFPage = "", selectedWorkflowId = 0;
        axios.post(API_URL + "module/workflow", { allModuleIds: allModuleIds }).then(result => {
            let allWorkflows = result.data;
            let workflowForPage = [{ WorkflowName: "Select Workflow" }];
            allWorkflows.forEach(workflow => {
                if (workflow.WorkflowName === selectedWorkflow) {
                    workflowForPage.push(workflow);
                    selectedWFPage = workflow.MappedPageList;
                    setSelectedWorkflow(workflow.WorkflowId)
                    selectedWorkflowId = workflow.WorkflowId;
                }

            });
            setSelectedModulePage(selectedWFPage);
            setWorkflowList(workflowForPage);
            if(selectedWorkflowId !== 0){
                getWorflowTreeForEdit({ target: { value: selectedWorkflowId } }, workflowForPage);
            }
        });
    }
      
      const fetchWorkflowsForPage = async (value) => {
        let allModuleIds = props.templateDetailsData.module.split(",").map((module: number) => module);
      
        try {
          const result = await axios.post(API_URL + "module/workflow", { allModuleIds });
      
          const workflowForPage = [{ WorkflowName: "Select Workflow" }];
          result.data.forEach(workflow => {
            if (workflow.WorkflowId === props.templateDetailsData.wfId) {
              workflowForPage.push(workflow);
            }
          });
          setWorkflowList(workflowForPage);
      
          return workflowForPage; // ✅ Return it
        } catch (error) {
          console.error("Error fetching workflows", error);
          return [];
        }
      };
      
    const handleModulePageSelection = async (event) => {
        const value = event.target.value
        
        fetchWorkflowsForPage(value)
            props.setTemplateDetailsData((prev: any) => ({
                ...prev,
                pageModuleId: value ? Number(value) : 0,
                type: "",
                name: "",
                description: "",
                wfId: 0
              }));              

    }

    const onTypeSelected = async (event) => {
        let selectedTypeObj = {};
        formType.forEach(formT => {
            if (event.target.value === formT.category) {
                selectedTypeObj = formT;
            }
        })
        props.setTemplateDetailsData((prev) => ({
            ...prev,
            type: event.target.value,
          }));              

        axios.post(API_URL + "templates/getPlaceholders", { formName: props.templateDetailsData.pageModuleId, category: event.target.value }).then(placeHoldersData => {
            props.setPlaceholdersForTemplates(placeHoldersData.data);
        })

        let tempName = '';
        
        if(workflowList.length > 1){
            props.setRequireWorkflowId(true)

            if(props.templateDetailsData.wfId !== 0){
                let workflowDetails = workflowList.find((item) => Number(item.WorkflowId) === Number(props.templateDetailsData.wfId));
                let tempName = workflowDetails?.WorkflowName + "_" + selectedTypeObj.name;
                props.setTemplateDetailsData((prev) => ({
                    ...prev,
                    name: tempName + "__This is local test",
                    description: tempName,
                  }));                  
            }
        }else if(workflowList.length === 1){
            const pageName = modulePages.find(m => m.ModulePageId == props.templateDetailsData.pageModuleId)?.ModulePageName || "";
            tempName = pageName + "_" + selectedTypeObj.name            
            props.setTemplateDetailsData((prev) => ({
                ...prev,
                name: tempName + "__This is local test",
                description: tempName,
              }));              
        }
    }

    const handleWorkflowSelection = async (event, workFlows) => {
        const list = workFlows && workFlows.length > 1 ? workFlows : workflowList
        const selectedWorkflow = list.find(
          (item) => Number(item.WorkflowId) === Number(event.target.value)
        );
      
        const approverData = selectedWorkflow?.workflowApprovalLevels;
        const workflowName = selectedWorkflow?.WorkflowName;
      
        const treeData = formatWorkflowTree(workflowName, approverData);
        setWorkflowTreeData(treeData);
        
        setXmltree(selectedWorkflow?.WorkflowDefinitionTree);
      
        return selectedWorkflow;
      };
      
    const getWorflowTree = async(event) => {
        props.setTemplateDetailsData((prev) => ({
            ...prev,
            wfId: event.target.value,
          }));   

          const selectedWorkFlow = await handleWorkflowSelection(event);

          const { module, pageModuleId, type } = props.templateDetailsData;
      
          if (module.split(",").length === 0 || pageModuleId === 0 || type === 0) {
            setOpen(true);
          } else {
            let selectedTypeObj = formType.find((formT) => type === formT.id) || {name : ""};
            const tempName = `${selectedWorkFlow?.workflowName}_${selectedTypeObj?.name}`;
            
            props.setTemplateDetailsData((prev) => ({
              ...prev,
              name: `${tempName}__This is local test`,
              description: tempName
            }));
          }
  
    }

    const getWorflowTreeForEdit = (event, allWorkflowList) => {
        if(allWorkflowList.length > 1){
            let workflowDetails = allWorkflowList.find((item) => Number(item.WorkflowId) === Number(event.target.value));
            setSelectedWorkflow(event.target.value)
            props.updateTemplateDetails("wfId", workflowDetails.WorkflowId);
            let approverData = workflowDetails?.workflowApprovalLevels
            let workflowName = workflowDetails?.WorkflowName ?? ''
            let workflowNodes = props.templateDetailsData.wfNodes.slice(1);
            let allWorkflowsSelections = workflowNodes.split(",");
            allWorkflowsSelections.push(workflowName);
            setSelectedNotiGrp(allWorkflowsSelections);
            setAllWorkflowsSelections(allWorkflowsSelections);
            let treeData = formatWorkflowTree(workflowName, approverData);
            setWorkflowTreeData(treeData);
            setXmltree(workflowDetails.WorkflowDefinitionTree)
            let templateNameArrya = props.templateDetailsData.name.split("_");
            let tempType = templateNameArrya[1];
            let selectedTypeObj = {name : ""};

            formType.forEach(formT => {
                if (tempType === formT.name) {
                    selectedTypeObj = formT;
                }
            })
            let tempName = workflowName + "_" + selectedTypeObj.name;
            setTemplateName(tempName + "__This is local test");
            setTemplateDescription(tempName);
            props.updateTemplateDetails("name", tempName + "__This is local test");
            props.updateTemplateDetails("description", tempName);
        }
    }

    return (
        <>
            <div className="grid grid-cols-3 gap-4 module-form-wrapper">
                <div className="p-1">
                    <div className="col-span-1 gap-4 place-content-center p-2 moduleselect">
                        <label htmlFor="modules" className="mr-4"><span className="asterisk">*</span>Modules:</label><br />
                        <Multiselect 
                            allModules={allModules} 
                            onChange={handleModuleSelection} 
                            editTemp={props.editTemp} 
                            selectedTemplateModules={props.templateDetailsData.module} 
                            templateId={props.templateDetailsData?.templateId}
                        />
                    </div>
                    <div className="col-span-1 gap-4 place-content-center p-2">
                        <label htmlFor="formType" className="mr-4"><span className="asterisk">*</span>Approval & Notification Type:</label>
                        <select className="template-details-inputs" disabled={props.showTemplatePreview} name="formType" onChange={onTypeSelected} value={props.templateDetailsData.type}>
                            {formType.map((form) => {
                                return <option key={form.name} value={form.category}>{form.name}</option>
                            })}
                        </select>
                    </div>
                    <div className="col-span-2 gap-4 place-content-center p-2">
                        <label htmlFor="tempname" className="mr-4"><span className="asterisk">*</span>Name:</label>
                        <input className="template-details-inputs" type="text" readOnly name="tempname" value={props.templateDetailsData.name} />
                    </div>
                    <div className="col-span-1 gap-4 place-content-center p-2">
                        <label htmlFor="description" className="mr-4">Description:</label><br />
                        <textarea className="template-details-textarea" readOnly name="description" value={props.templateDetailsData.description} />
                    </div>
                    <div className="col-span-2 gap-4 place-content-center p-2">
                    <label htmlFor="subject" className="mr-4"><span className="asterisk">*</span>Subject:</label>
                    <textarea 
                        disabled={props.showTemplatePreview} 
                        name="subject" 
                        className="template-details-textarea" 
                        onChange={(event) =>
                            props.setTemplateDetailsData((prev) => ({
                              ...prev,
                              subject: event.target.value
                            }))
                          }
                        value={props.templateDetailsData.subject} 
                    />
                </div>
                </div>
                <div className="p-1">
                    <div className="col-span-1 gap-4 place-content-center p-2">
                        <label htmlFor="modulepage" className="mr-4"><span className="asterisk">*</span>Actions (Pages), Events:</label><br />
                        <select className="template-details-inputs" disabled={props.showTemplatePreview} name="modulepage" value={props.templateDetailsData.pageModuleId} onChange={(event) => handleModulePageSelection(event)}>
                            {modulePages.map(modPage => {
                                return <option key={modPage.ModulePageName} value={modPage.ModulePageId}>{modPage.ModulePageName}</option>
                            })}
                        </select>
                    </div>
                    <div className="col-span-1 gap-4 place-content-center p-2">
                     {workflowList.length !== 1 ? <><label htmlFor="workflow" className="mr-4"><span className="asterisk">*</span>Workflow:</label><br />
                        <select className="template-details-inputs" disabled={props.showTemplatePreview} name="workflow" onChange={getWorflowTree} value={props.templateDetailsData.wfId}>
                            {workflowList.map(workflow => {
                                return <option key={workflow.WorkflowName} value={workflow.WorkflowId}>{workflow.WorkflowName}</option>
                            })}
                        </select></> : <div style={{ height: '40px' }}></div>}
                    </div>
                    <div className="col-span-1 gap-4 place-content-center p-2">
                        <label htmlFor="status" className="mr-2">Status:</label>&nbsp;&nbsp;
                            <input 
                                type="radio" 
                                name="status" 
                                value="Active" 
                                aria-label="Active" 
                                checked={props.templateDetailsData.active === 'Y'}
                                onChange={() => props.setTemplateDetailsData(prev => ({ ...prev, active: 'Y' }))}                                disabled={props.showTemplatePreview}>
                            </input> Active  
                            <input 
                                type="radio" 
                                name="status" 
                                value="InActive" 
                                aria-label="InActive" 
                                checked={props.templateDetailsData.active === 'N'}
                                onChange={() => props.setTemplateDetailsData(prev => ({ ...prev, active: 'N' }))}                                disabled={props.showTemplatePreview}>
                            </input> InActive
                    </div>
                </div>
                <div className="p-1 workflow-tree-wrapper">
                <div className="col-span-1 gap-4 place-content-center p-2">
                    {workflowList.length > 1 ? <><label htmlFor="status" className="mr-2">Workflow:(Disabled nodes are already used in existing template(s))</label>
                        {/* <Stack direction="row" spacing={1}>
                            {selectedNotiGrp.length > 0 && selectedNotiGrp.map(NotiGrp => {
                                return <Chip key={NotiGrp} label={NotiGrp} variant="outlined" />
                            })}
                        </Stack> */}
                        <WorkflowStructure xmlTree={xmlTree} workflowTreeData={workflowTreeData} updateTemplateDetails={props.updateTemplateDetails} editTemp = {props.editTemp} templateId = {props.templateDetailsData?.templateId} allWorkflowsSelections={allWorkflowsSelections} templateDetailsData = {props.templateDetailsData} setTemplateDetailsData={props.setTemplateDetailsData}/>
                        </> : workflowList.length === 1 ? <label htmlFor="status" className="mr-2" style={{ fontStyle: 'italic', color: 'dodgerblue', marginTop: '30px'}}>No Workflow is available.</label> : <></>
                        }
                    </div>

                </div>
                
            </div>
            <Dialog
                open={open}
                slots={{
                    transition: Transition,
                }}
                keepMounted
                onClose={handleClose}
                aria-describedby="alert-dialog-slide-description"
            >
                <DialogContent>
                    <DialogContentText id="alert-dialog-slide-description">
                        Please select Approval & Notification Type
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                </DialogActions>
            </Dialog>
        </>
    );
}